// utils/uuid.js
export function generateRandomString() {
  // 生成32位十六进制字符串（类似UUID去掉横杠）
  return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}



// WEBPACK FOOTER //
// ./src/utils/uuid.js